import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthenticationService } from '../security/authentication.service';
import { LoaderService } from './loader/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { isLoaderHidden } from './utils.service';
import { GenericErrorModalComponent } from '../container/modal/generic-error-modal/generic-error-modal.component';

@Injectable()
export class RESTInterceptor implements HttpInterceptor {
  requestNum = 0;

  constructor(private dialog: MatDialog, private authenticationService: AuthenticationService, private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authenticationService.getAccessToken();
    const finalReq = req.clone(
      token ? { withCredentials: true, setHeaders: { Authorization: `Bearer ${token}` } } : { withCredentials: true }
    );

    let timer;

    if (!isLoaderHidden(req.headers)) {
      this.requestNum++;
      timer = setTimeout(() => {
        this.showLoader();
      }, 0.1 * 1000);
    }

    return next.handle(finalReq).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse && (err.status === 401 || err.status === 403)) {
          return from(this.authenticationService.refreshToken()).pipe(
            switchMap((ok) => {
              if (ok) {
                const newToken = this.authenticationService.getAccessToken();
                const retryReq = req.clone(
                  newToken ? { withCredentials: true, setHeaders: { Authorization: `Bearer ${newToken}` } } : { withCredentials: true }
                );
                return next.handle(retryReq);
              }
              this.authenticationService.login();
              return throwError(() => err);
            })
          );
        }

        if (err instanceof HttpErrorResponse) {
          if (err.error instanceof Blob) {
            err.error.text().then((error) => {
              this.showError(err.status, error);
            });
          } else {
            this.showError(err.status, err.error);
          }
        }
        return throwError(() => err);
      }),
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (!isLoaderHidden(req.headers)) {
            this.requestNum--;
          }
          if (this.requestNum <= 0) {
            this.hideLoader();
            this.requestNum = 0;
          }
          clearTimeout(timer);
        }
      })
    );
  }

  private showError(status: number, error: string) {
    const errDialog = this.dialog.open(GenericErrorModalComponent, {
      width: '350px',
      data: error,
    });

    errDialog.afterClosed().subscribe(() => {
      this.hideLoader();
      this.requestNum = 0;
      if (status === 401) {
        location.reload();
      }
    });
  }

  private showLoader(): void {
    this.loaderService.show();
  }

  private hideLoader(): void {
    this.loaderService.hide();
  }
}
